import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import OpenCloseIcon from "@/views/blocks/common/OpenCloseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HamburgerButton',
  props: {
    textColor: {}
  },
  emits: ["openMenu"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "0a2d8f4b": (_ctx.textColor)
}))



const emit = __emit;

const handleOpen = () => {
    emit("openMenu");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "inline-flex items-center justify-center lg:hidden rounded-md",
    onClick: handleOpen
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)),
    _createVNode(OpenCloseIcon, { "is-open": false })
  ]))
}
}

})